// Stato della vetrina avanzata dell'artigiano loggato (GET /api/shops/me).
// Condiviso tra il selettore base/avanzata e l'editor della vetrina avanzata.
import { useCallback, useEffect, useState } from 'react';
import { fetchMyShop } from '../lib/shopsApi';
import { DEFAULT_BRANDING, normalizeMenu } from '../lib/shopThemes';

const normalize = (data) => ({
  canCustomize: !!data?.can_customize,
  accessReason: data?.access_reason || null,
  branding: { ...DEFAULT_BRANDING, ...(data?.branding || {}) },
  contact: data?.branding?.contact || null,
  policies: data?.branding?.policies || null,
  menu: normalizeMenu(data?.menu),
  featured_product_ids: data?.featured_product_ids || [],
  collections: data?.collections || [],
  is_published: !!data?.is_published,
});

export function useMyShop(enabled = true) {
  const [state, setState] = useState({ loading: true, error: null, shop: null });

  const reload = useCallback(async () => {
    setState((s) => ({ ...s, loading: true, error: null }));
    try {
      const data = await fetchMyShop();
      setState({ loading: false, error: null, shop: normalize(data) });
    } catch (e) {
      setState({ loading: false, error: e.message, shop: null });
    }
  }, []);

  useEffect(() => {
    if (enabled) reload();
  }, [enabled, reload]);

  // Aggiorna lo stato locale con la risposta di un salvataggio (PUT /api/shops/me)
  const applySaved = useCallback((data) => {
    setState((s) => ({
      ...s,
      shop: { ...normalize(data), canCustomize: true, accessReason: s.shop?.accessReason || null },
    }));
  }, []);

  return { ...state, reload, applySaved };
}
